import {
  ChangeDetectionStrategy,
  Component,
  inject,
  computed,
} from '@angular/core'

import { TypographyComponent } from '@hyperkit'

import {
  HuntViewService,
  HuntEditorService,
  SessionService,
  DebuggerService,
} from '@hunt/services'

import { HuntEditorComponent } from '../../details/components/hunt-editor'

@Component({
  standalone: true,
  selector: 'edit-report-overview',
  imports: [TypographyComponent, HuntEditorComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './edit-report-overview.component.html',
  styleUrls: ['edit-report-overview.component.scss'],
})
export class EditReportOverviewComponent {
  readonly huntView = inject(HuntViewService)
  readonly huntEditor = inject(HuntEditorService)
  readonly session = inject(SessionService)
  readonly debugger = inject(DebuggerService)
  // ENSURE: the session is loaded before rendering
  readonly loaded = computed(
    () => !this.session.loading() && this.session.activeHunt() !== null,
  )
}
